<template>
  <div class="footer-section">
    <div class="main-container">
      <div class="footer-row">
        <div class="footer-logo">
          <img src="../../assets/logo/seu-logo.svg" alt="">
        </div>
        <footer-contact-column/>
        <footer-link-column/>
        <footer-link-column2
          @openPopup="openPopup"
        />
        <footer-contact-column2/>
      </div>
      <div class="footer-row">
        <div class="copyright caption">{{$t('footer.copyright')}}</div>
        <div class="arrow-container">
          <div class="line"></div>
          <img class="arrowhead" src="../../assets/icons/arrow-right-divider.svg" alt="">
        </div>
        <div class="link-container overline">
          <div class="nav-link" @click="openPopup('IMPRESSUM')">{{$t('footer.imprint')}}</div>
          <div class="nav-link" @click="openPopup('TERMS')">{{$t('footer.terms')}}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import FooterContactColumn from "/seu-frontend/components/FooterContactColumn";
import FooterLinkColumn from "/seu-frontend/components/FooterLinkColumn";
import FooterLinkColumn2 from "/seu-frontend/components/FooterLinkColumn2";
import FooterContactColumn2 from "/seu-frontend/components/FooterContactColumn2";

export default {
  name: "FooterSection",
  components: {FooterContactColumn2, FooterLinkColumn2, FooterLinkColumn, FooterContactColumn},

  methods: {
    openPopup(data) {
      this.$emit('openPopup', data);
    }
  }
}
</script>

<style lang="scss">
@import "FooterSection.scss";
</style>
